export const CURRENT_APP_VER = '0.0.0';
